import isBefore from "date-fns/isBefore";
export var hasFaireDirectFirstOrderIncentive = function(faireDirectFirstOrderIncentive) {
    if (!faireDirectFirstOrderIncentive) {
        return false;
    }
    var claimedAt = faireDirectFirstOrderIncentive.claimed_at, expiresAt = faireDirectFirstOrderIncentive.expires_at;
    return !claimedAt && isBefore(Date.now(), expiresAt !== null && expiresAt !== void 0 ? expiresAt : 0);
};
